export default __webpack_public_path__ + "static/media/whyBrokerImg.0748f02c.webp";